import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollable } from '../../hooks';
import { NextController, PreviousController, StyledItemWrapper, StyledList, StyledWrapper, } from './ScrollableCarousel.style';
export function ScrollableCarousel({ children, controllerStyle = 'shadow', controllerVisibility = 'auto', scrollThreshold = 10, }) {
    var _a, _b;
    const { isScrollableX, scrollableRef, scrollX, scrollToLeft, scrollToRight } = useScrollable();
    const showControllers = controllerVisibility === 'visible' ||
        (controllerVisibility === 'hidden' ? false : isScrollableX);
    const showPreviousController = scrollX > scrollThreshold;
    const showNextController = !!((scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) &&
        scrollX + scrollThreshold <
            ((_a = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) - ((_b = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth));
    const variant = {
        visibility: controllerVisibility === 'auto'
            ? isScrollableX
                ? 'visible'
                : 'hidden'
            : controllerVisibility,
        style: controllerStyle,
    };
    return (_jsxs(StyledWrapper, { variant: variant, children: [showControllers && (_jsxs(_Fragment, { children: [_jsx(PreviousController, { visible: showPreviousController, variant: variant, onClick: scrollToLeft }), _jsx(NextController, { visible: showNextController, variant: variant, onClick: scrollToRight })] })), _jsx(StyledList, { ref: scrollableRef, variant: variant, children: children })] }));
}
export { StyledItemWrapper as ScrollableCarouselItem };
//# sourceMappingURL=ScrollableCarousel.js.map